import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

// A person's display name: prefer the Dhivehi name (nameDv), falling back to the
// English `name` only when no Dhivehi name exists. WapMeet shows Dhivehi names
// everywhere — use this for every rendered person name.
export function displayName(u: { name: string; nameDv?: string | null }): string {
  return u.nameDv?.trim() || u.name;
}
